var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{attrs:{"variant":"primary","depressed":"","tile":""},on:{"click":function($event){return _vm.$emit('click')}}},[_c('b-icon',{attrs:{"icon":"printer","aria-hidden":"true"}}),_vm._t("default",function(){return [_vm._v(" Print ")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }